import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import myConnections from "../../utility/connect.js"

const sliceName = "loginSlice"
export const localStorageUserIdentifier = "userInfo"
export const localStorageCredentialsIdentifier = "credentialsInfo"

const initialState = {
  login: {
    isLoggedIn: false,
    token: {
      token: null,
      expiresIn: null,
      createdTS: null,
      expiresOn: null,
      expired: false,
    },
    isLoggingInBucket: [],
    isReloggingInBucket: [],
    error: { errorMsg: "" },
    success: { successMsg: "" },
    errorMeta: {
      serverErrorCount: 0,
      lastServerErrorTimestamp: null,
      lastErrorTimestamp: null,
    },
    loginMethod: null,
    isWithSocialNetwork: false,
    userInfo: {
      id: null,
      email: null,
      hEmail: null,
      mobileCountryStart: null,
      phoneNumber: null,
      fullPhoneNumber: null,
      isMailVerified: null,
      canAskForMailVerificationAgain: false,
      askingForMailVerificationTokenAgainBucket: [],
      isPhoneVerified: null,
      canAskForSMSverificationTokenAgain: false,
      askingForSMSverifiationTokenAgainBucket: [],
      ci: null,
    },
  },
  register: {
    isRegistringBucket: [],
    error: { errorMsg: "" },
    success: { successMsg: "" },
  },
}

/***
 *                     _   _               _
 *      _ __ ___   ___| |_| |__   ___   __| |___
 *     | '_ ` _ \ / _ \ __| '_ \ / _ \ / _` / __|
 *     | | | | | |  __/ |_| | | | (_) | (_| \__ \
 *     |_| |_| |_|\___|\__|_| |_|\___/ \__,_|___/
 *
 */

const saveLoginResultToState = (pState, pResultFromDB) => {
  //takes parsed result

  const id = pResultFromDB.nb1
  const mail = pResultFromDB.vc1
  const phoneNumber = pResultFromDB.vc2
  const isMailVerified = pResultFromDB.vc3 === "Y"
  const isPhoneVerified = pResultFromDB.vc4 === "Y"
  const loginMethod = pResultFromDB.vc5
  const hEmail = pResultFromDB.vc6
  const token = pResultFromDB.vc7
  const clientId = pResultFromDB.vc8
  const expiresIn = pResultFromDB.nb2
  const mobileCountryStart = pResultFromDB.vc9

  pState.login.loginMethod = loginMethod

  //token
  pState.login.token.token = token
  pState.login.token.expiresIn = expiresIn * 1000 //miliseknude
  pState.login.token.createdTS = Date.now()
  pState.login.token.expiresOn =
    pState.login.token.createdTS + pState.login.token.expiresIn

  //userinfo
  pState.login.userInfo.id = id
  pState.login.userInfo.email = mail
  pState.login.userInfo.mobileCountryStart = mobileCountryStart
  pState.login.userInfo.phoneNumber = phoneNumber
  pState.login.userInfo.fullPhoneNumber = `${mobileCountryStart ?? ""}${
    phoneNumber ?? ""
  }`
  if (pState.login.userInfo.fullPhoneNumber) {
    pState.login.userInfo.fullPhoneNumber =
      "+" + pState.login.userInfo.fullPhoneNumber
  }
  pState.login.userInfo.isMailVerified = isMailVerified
  pState.login.userInfo.isPhoneVerified = isPhoneVerified
  pState.login.userInfo.ci = clientId
  pState.login.userInfo.hEmail = hEmail

  return true
}

/***
 *                _ _                                           _            _
 *       __ _ ___(_) |__  _ __ ___  _ __   ___   _ __ ___   ___| |_ ___   __| | ___
 *      / _` / __| | '_ \| '__/ _ \| '_ \ / _ \ | '_ ` _ \ / _ \ __/ _ \ / _` |/ _ \
 *     | (_| \__ \ | | | | | | (_) | | | |  __/ | | | | | |  __/ || (_) | (_| |  __/
 *      \__,_|___/_|_| |_|_|  \___/|_| |_|\___| |_| |_| |_|\___|\__\___/ \__,_|\___|
 *
 */

/***
 *      _             _
 *     | | ___   __ _(_)_ __
 *     | |/ _ \ / _` | | '_ \
 *     | | (_) | (_| | | | | |
 *     |_|\___/ \__, |_|_| |_|
 *              |___/
 */

let login = async ({ username, password }, thunkAPI) => {
  const response = await myConnections.login({
    thunkAPI: thunkAPI,
    data: {
      P_USER_IDENTIFIER: username,
      P_PASSWORD: password,
    },
  })

  return response
}

login = createAsyncThunk(`${sliceName}/login`, login)
login.myLC = {
  pending: (state, action) => {
    const loginId = action.meta.arg.loginId
    state.login.isLoggingInBucket.push({ id: loginId })
  },
  fulfilled: (state, { payload, meta }) => {
    const loginId = meta.arg.loginId
    state.login.isLoggingInBucket = state.login.isLoggingInBucket.filter(
      (element) => element.id !== loginId
    )
    const result = JSON.parse(payload.P_RESULT)
    saveLoginResultToState(state, result)
    state.login.isLoggedIn = true
  },
  rejected: (state, { payload, meta }) => {
    const loginId = meta.arg.loginId
    state.login.isLoggingInBucket = state.login.isLoggingInBucket.filter(
      (element) => element.id !== loginId
    )
    if (payload.isErrorOnServer === true) {
      state.login.errorMeta.serverErrorCount++
      state.login.errorMeta.lastServerErrorTimestamp = Date.now()
    }
    state.login.error.errorMsg = payload.message
    state.login.errorMeta.lastErrorTimestamp = Date.now()
  },
}

/***********************TU DELAMO */

let loginWithSocialNetwork = async ({ code, type }, thunkAPI) => {
  console.log("=== Social Login API Call ===")
  console.log("Request details:", {
    code,
    type,
    url: "oauth2_unsecure/social_network_oauth",
  })

  const response = await myConnections.post({
    thunkAPI: thunkAPI,
    path: "oauth2_unsecure/social_network_oauth",
    data: {
      code: code,
      type: type,
    },
  })

  console.log("Raw API Response:", response)
  console.log("==================================")
  return response
}

loginWithSocialNetwork = createAsyncThunk(
  `${sliceName}/loginWithSocialNetwork`,
  loginWithSocialNetwork
)
loginWithSocialNetwork.myLC = {
  pending: (state, action) => {
    console.log("=== Social Login State Update - Pending ===")
    console.log("Action:", action)
    console.log("==================================")
  },
  fulfilled: (state, { payload, meta }) => {
    console.log("=== Social Login State Update - Fulfilled ===")
    console.log("Payload:", payload)
    const result = JSON.parse(payload.P_RESULT)
    console.log("Parsed Result:", result)

    if (result.isSuccess === true && result.vc1 !== "noCustomer") {
      console.log("Login successful, updating state")
      saveLoginResultToState(state, result)
      state.login.isLoggedIn = true
      state.login.isWithSocialNetwork = true
    } else {
      console.log("Login unsuccessful:", {
        isSuccess: result.isSuccess,
        vc1: result.vc1,
        error: result.error,
      })
    }
    console.log("==================================")
  },
  rejected: (state, { payload, meta }) => {
    console.log("=== Social Login State Update - Rejected ===")
    console.log("Error Payload:", payload)
    console.log("Meta:", meta)
    console.log("==================================")
  },
}

/***
 *                 _                _
 *      _ __  ___ | |  ___    __ _ (_) _ __
 *     | '__|/ _ \| | / _ \  / _` || || '_ \
 *     | |  |  __/| || (_) || (_| || || | | |
 *     |_|   \___||_| \___/  \__, ||_||_| |_|
 *                           |___/
 */

let relogin = async ({ id }, thunkAPI) => {
  const response = await myConnections.relogin({
    thunkAPI: thunkAPI,
    localStorageIdentifier: localStorageUserIdentifier,
    data: {},
  })
  return response
}

relogin = createAsyncThunk(`${sliceName}/relogin`, relogin)
relogin.myLC = {
  pending: (state, action) => {
    const loginId = action.meta.arg.loginId
    const reloginId = action.meta.arg.reloginId
    state.login.isLoggingInBucket.push({ id: loginId })
    state.login.isReloggingInBucket.push({ id: reloginId })
  },
  fulfilled: (state, { payload, meta }) => {
    const loginId = meta.arg.loginId
    const reloginId = meta.arg.reloginId

    state.login.isReloggingInBucket = state.login.isReloggingInBucket.filter(
      (element) => element.id !== reloginId
    )
    state.login.isLoggingInBucket = state.login.isLoggingInBucket.filter(
      (element) => element.id !== loginId
    )

    state.login.isLoggedIn = true
    const result = JSON.parse(payload.P_RESULT)
    saveLoginResultToState(state, result)
  },
  rejected: (state, action) => {
    const loginId = action.meta.arg.loginId
    const reloginId = action.meta.arg.reloginId
    state.login.isReloggingInBucket = state.login.isReloggingInBucket.filter(
      (element) => element.id !== reloginId
    )
    state.login.isLoggingInBucket = state.login.isLoggingInBucket.filter(
      (element) => element.id !== loginId
    )
  },
}

/***
 *                        _       _
 *      _ __  ___   __ _ (_) ___ | |_  ___  _ __
 *     | '__|/ _ \ / _` || |/ __|| __|/ _ \| '__|
 *     | |  |  __/| (_| || |\__ \| |_|  __/| |
 *     |_|   \___| \__, ||_||___/ \__|\___||_|
 *                 |___/
 */

let register = async (
  {
    email,
    password,
    mobile,
    mobilePrefix,
    confirmPassword,
    name,
    surname,
    refcode,
    permission1,
    permission2,
    permission3,
    permission4,
    townCity,
    isWithSocialNetwork,
    socialNetworkId,
    socialNetworkType,
  },
  thunkAPI
) => {
  const isMobileNull = (mobile ?? "") === ""
  const response = await myConnections.register({
    thunkAPI: thunkAPI,
    data: {
      P_EMAIL: email,
      P_MOBILE_COUNTRY_START: isMobileNull ? null : mobilePrefix,
      P_MOBILE: mobile,
      P_PASSWORD: password,
      P_CONFIRM_PASSWORD: confirmPassword,
      P_NAME: name,
      P_SURNAME: surname,
      P_REFCODE: refcode,
      P_PERMISSION1: permission1 ? "Y" : "N",
      P_PERMISSION2: permission2 ? "Y" : "N",
      P_PERMISSION3: permission3 ? "Y" : "N",
      P_PERMISSION4: permission4 ? "Y" : "N",
      P_TOWN_CITY: townCity,
      P_IS_WITH_SOCIAL_NETWORK: isWithSocialNetwork ? "Y" : "N",
      P_SOCIAL_NETWORK_ID: socialNetworkId,
      P_SOCIAL_NETWORK_TYPE: socialNetworkType,
    },
  })

  return response
}

register = createAsyncThunk(`${sliceName}/register`, register)
register.myLC = {
  pending: (state, action) => {
    state.register.isRegistringBucket.push({})
  },
  fulfilled: (state, { payload }) => {
    state.register.isRegistringBucket.shift()
    state.register.success.successMsg = "registrationSuccess"
  },
  rejected: (state, action) => {
    state.register.isRegistringBucket.shift()
    state.register.error.errorMsg = action.payload.message
  },
}

/***
 *                     _  __ _           _   _                           _           _   _
 *     __   _____ _ __(_)/ _(_) ___ __ _| |_(_) ___  _ __  ___          | |__   ___ | |_| |__
 *     \ \ / / _ \ '__| | |_| |/ __/ _` | __| |/ _ \| '_ \/ __|  _____  | '_ \ / _ \| __| '_ \
 *      \ V /  __/ |  | |  _| | (_| (_| | |_| | (_) | | | \__ \ |_____| | |_) | (_) | |_| | | |
 *       \_/ \___|_|  |_|_| |_|\___\__,_|\__|_|\___/|_| |_|___/         |_.__/ \___/ \__|_| |_|
 *
 */

///////////////////////////////////////////////////////////////////////////////////////////////////checkCurrentVerificationStatus
//chekira dal je useri mail verificiratni i dal je useru mobitel verificirani
let checkCurrentVerificationStatus = async (_, thunkAPI) => {
  let response = await myConnections.get({
    path: `customers/get_customers_verifications`,
    thunkAPI: thunkAPI,
    turnOnLoading: false,
  })

  return response
}

checkCurrentVerificationStatus = createAsyncThunk(
  `${sliceName}/checkCurrentVerificationStatus`,
  checkCurrentVerificationStatus
)
checkCurrentVerificationStatus.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, { payload, meta }) => {
    const isMailVerified = payload.items[0]?.verified_email === "Y"
    const isPhoneVerified = payload.items[0]?.verified_mobile === "Y"

    state.login.userInfo.isMailVerified = isMailVerified
    state.login.userInfo.isPhoneVerified = isPhoneVerified
  },
  rejected: (state, action) => {},
}

/***
 *                     _  __ _           _   _                                                _ _
 *     __   _____ _ __(_)/ _(_) ___ __ _| |_(_) ___  _ __  ___            ___ _ __ ___   __ _(_) |
 *     \ \ / / _ \ '__| | |_| |/ __/ _` | __| |/ _ \| '_ \/ __|  _____   / _ \ '_ ` _ \ / _` | | |
 *      \ V /  __/ |  | |  _| | (_| (_| | |_| | (_) | | | \__ \ |_____| |  __/ | | | | | (_| | | |
 *       \_/ \___|_|  |_|_| |_|\___\__,_|\__|_|\___/|_| |_|___/          \___|_| |_| |_|\__,_|_|_|
 *
 */

///////////////////////////////////////////////////////////////////////////////////////////////////canAskForMailVerificationTokenAgain
//pita dal moze zatraziti novi token za mail
let canAskForMailVerificationTokenAgain = async (
  showLoading = false,
  thunkAPI
) => {
  let response = await myConnections.get({
    path: `verifications/check_token_activity`,
    headers: { P_VERIFICATION_TYPE: "E" },
    thunkAPI: thunkAPI,
    turnOnLoading: showLoading,
  })
  return response
}

canAskForMailVerificationTokenAgain = createAsyncThunk(
  `${sliceName}/canAskForMailVerificationTokenAgain `,
  canAskForMailVerificationTokenAgain
)
canAskForMailVerificationTokenAgain.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, { payload }) => {
    const result = JSON.parse(payload.P_RESULT)
    const canAskAgain = result.isSuccess
    if (
      state.login.userInfo.askingForMailVerificationTokenAgainBucket.length ===
      0
    ) {
      state.login.userInfo.canAskForMailVerificationAgain = canAskAgain
    }
  },
  rejected: (state, action) => {},
}

///////////////////////////////////////////////////////////////////////////////////////////////////sendMailVerificationAgain
//šalje novi token za mail
let sendMailVerificationAgain = async (_, thunkAPI) => {
  let response = await myConnections.post({
    path: `verifications/send_email_verification_token`,
    thunkAPI: thunkAPI,
  })

  return response
}

sendMailVerificationAgain = createAsyncThunk(
  `${sliceName}/sendMailVerificationAgain `,
  sendMailVerificationAgain
)
sendMailVerificationAgain.myLC = {
  pending: (state, action) => {
    state.login.userInfo.canAskForMailVerificationAgain = false
    state.login.userInfo.askingForMailVerificationTokenAgainBucket.push({})
  },
  fulfilled: (state, { payload }) => {
    state.login.userInfo.askingForMailVerificationTokenAgainBucket.shift()
  },
  rejected: (state, action) => {
    state.login.userInfo.askingForMailVerificationTokenAgainBucket.shift()
  },
}

///////////////////////////////////////////////////////////////////////////////////////////////////verifyMailToken
//verificira token za mail
let verifyMailToken = async ({ token, cid, he }, thunkAPI) => {
  let response = await myConnections.get({
    path: `verifications/verify_token?P_TOKEN=${token}&P_VERIFICATION_TYPE=E`,
    thunkAPI: thunkAPI,
    headers: { P_CUSTOMERS_ID: cid, P_HASHED_EMAIL: he },
  })

  return response
}

verifyMailToken = createAsyncThunk(
  `${sliceName}/verifyMailToken`,
  verifyMailToken
)
verifyMailToken.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, { payload }) => {
    const parsedResult = JSON.parse(payload.P_RESULT)
    state.login.userInfo.isMailVerified = parsedResult.isSuccess
  },
  rejected: (state, action) => {},
}

/***
 *                     _  __ _           _   _
 *     __   _____ _ __(_)/ _(_) ___ __ _| |_(_) ___  _ __  ___           ___ _ __ ___  ___
 *     \ \ / / _ \ '__| | |_| |/ __/ _` | __| |/ _ \| '_ \/ __|  _____  / __| '_ ` _ \/ __|
 *      \ V /  __/ |  | |  _| | (_| (_| | |_| | (_) | | | \__ \ |_____| \__ \ | | | | \__ \
 *       \_/ \___|_|  |_|_| |_|\___\__,_|\__|_|\___/|_| |_|___/         |___/_| |_| |_|___/
 *
 */

let canAskForSMSverificationTokenAgain = async (
  showLoading = false,
  thunkAPI
) => {
  let response = await myConnections.get({
    path: `verifications/check_token_activity`,
    headers: { P_VERIFICATION_TYPE: "S" },
    thunkAPI: thunkAPI,
    turnOnLoading: showLoading,
  })
  return response
}

canAskForSMSverificationTokenAgain = createAsyncThunk(
  `${sliceName}/canAskForSMSverificationTokenAgain `,
  canAskForSMSverificationTokenAgain
)
canAskForSMSverificationTokenAgain.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, { payload }) => {
    const result = JSON.parse(payload.P_RESULT)
    const canAskAgain = result.isSuccess
    if (
      state.login.userInfo.askingForSMSverifiationTokenAgainBucket.length === 0
    ) {
      state.login.userInfo.canAskForSMSverificationTokenAgain = canAskAgain
    }
  },
  rejected: (state, action) => {},
}

///////////////////////////////////////////////////////////////////////////////////////////////////sendSMSverificationAgain
//�alje novi token za mail
let sendSMSverificationAgain = async (_, thunkAPI) => {
  let response = await myConnections.post({
    path: `verifications/send_mobile_verification_token`,
    thunkAPI: thunkAPI,
  })

  return response
}

sendSMSverificationAgain = createAsyncThunk(
  `${sliceName}/sendSMSverificationAgain `,
  sendSMSverificationAgain
)
sendSMSverificationAgain.myLC = {
  pending: (state, action) => {
    state.login.userInfo.canAskForSMSverificationTokenAgain = false
    state.login.userInfo.askingForSMSverifiationTokenAgainBucket.push({})
  },
  fulfilled: (state, { payload }) => {
    state.login.userInfo.askingForSMSverifiationTokenAgainBucket.shift()
  },
  rejected: (state, action) => {
    state.login.userInfo.askingForSMSverifiationTokenAgainBucket.shift()
  },
}

///////////////////////////////////////////////////////////////////////////////////////////////////verifyMailToken
//verificira token za mail
let verifySMStoken = async ({ token }, thunkAPI) => {
  let response = await myConnections.get({
    path: `verifications/verify_token?P_TOKEN=${token}&P_VERIFICATION_TYPE=S`,
    thunkAPI: thunkAPI,
  })

  return response
}

verifySMStoken = createAsyncThunk(`${sliceName}/verifySMStoken`, verifySMStoken)
verifySMStoken.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, { payload }) => {
    const res = JSON.parse(payload.P_RESULT)
    state.login.userInfo.isPhoneVerified = res.isSuccess
  },
  rejected: (state, action) => {},
}

/***
 *           _                                                                        _   _        _
 *       ___| |__   __ _ _ __   __ _  ___   _ __   __ _ ___ _____      _____  _ __ __| | | |_ ___ | | _____ _ __  ___
 *      / __| '_ \ / _` | '_ \ / _` |/ _ \ | '_ \ / _` / __/ __\ \ /\ / / _ \| '__/ _` | | __/ _ \| |/ / _ \ '_ \/ __|
 *     | (__| | | | (_| | | | | (_| |  __/ | |_) | (_| \__ \__ \\ V  V / (_) | | | (_| | | || (_) |   <  __/ | | \__ \
 *      \___|_| |_|\__,_|_| |_|\__, |\___| | .__/ \__,_|___/___/ \_/\_/ \___/|_|  \__,_|  \__\___/|_|\_\___|_| |_|___/
 *                             |___/       |_|
 */

///generateChangePassToken
///////////////////////////////////////////////////////////////////////////////////////////////////
let generateChangePassToken = async ({ pUserIdentifier }, thunkAPI) => {
  let response = await myConnections.post({
    path: `verifications/forgotten_password`,
    thunkAPI: thunkAPI,
    data: { P_USER_IDENTIFIER: pUserIdentifier },
  })

  return response
}

generateChangePassToken = createAsyncThunk(
  `${sliceName}/generateChangePassToken `,
  generateChangePassToken
)
generateChangePassToken.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, { payload }) => {},
  rejected: (state, action) => {},
}

///canChangePassword
///////////////////////////////////////////////////////////////////////////////////////////////////
let canChangePassword = async (
  { pToken, pUserIdentifier, pMethod },
  thunkAPI
) => {
  let response = await myConnections.post({
    path: `verifications/forgotten_password_can_change`,
    thunkAPI: thunkAPI,
    data: {
      P_TOKEN: pToken,
      P_USER_IDENTIFIER: pUserIdentifier,
      P_METHOD: pMethod,
    },
  })

  return response
}

canChangePassword = createAsyncThunk(
  `${sliceName}/canChangePassword `,
  canChangePassword
)
canChangePassword.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, { payload }) => {},
  rejected: (state, action) => {},
}

///changePassword
///////////////////////////////////////////////////////////////////////////////////////////////////
let changePassword = async (
  { password, confirmPassword, pToken, pUserIdentifier, pMethod },
  thunkAPI
) => {
  let response = await myConnections.post({
    path: `verifications/forgotten_password_change_password`,
    thunkAPI: thunkAPI,
    data: {
      P_METHOD: pMethod,
      P_USER_IDENTIFIER: pUserIdentifier,
      P_TOKEN: pToken,
      P_PASSWORD: password,
      P_CONFIRM_PASSWORD: confirmPassword,
    },
  })

  return response
}

changePassword = createAsyncThunk(
  `${sliceName}/changePassword `,
  changePassword
)
changePassword.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, { payload }) => {},
  rejected: (state, action) => {},
}

///////////////////////////////////////////////////////////////////////////////////////////////////deactivate account

let deactivateAccount = async (_, thunkAPI) => {
  let response = await myConnections.post({
    path: `customers_protected/deactivate_customer`,
    thunkAPI: thunkAPI,
    data: {},
  })

  return response
}

deactivateAccount = createAsyncThunk(
  `${sliceName}/deactivateAccount `,
  deactivateAccount
)
deactivateAccount.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, { payload }) => {},
  rejected: (state, action) => {},
}

///////////////////////////////////////////////////////////////////////SINHRONE METODE

const resetLoginError = (state, action) => {
  state.login.error = initialState.login.error
  state.login.success = initialState.login.success
}

const resetRegisterError = (state, action) => {
  state.register.error = initialState.register.error
}

const logout = (state, action) => {
  const currentTokenState = state.login.token.expired

  state.login = {
    ...initialState.login,
    token: { ...initialState.token, expired: currentTokenState },
  }
}

const expireToken = (state, action) => {
  state.login.token.expired = true
}

//////////////////////////////////////////////////////////////// SLICE

const loginSlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: {
    resetLoginError,
    resetRegisterError,
    logout,
    expireToken,
  },
  extraReducers: (builder) => {
    builder.addCase(login.pending, login.myLC.pending)
    builder.addCase(login.fulfilled, login.myLC.fulfilled)
    builder.addCase(login.rejected, login.myLC.rejected)

    builder.addCase(
      loginWithSocialNetwork.pending,
      loginWithSocialNetwork.myLC.pending
    )
    builder.addCase(
      loginWithSocialNetwork.fulfilled,
      loginWithSocialNetwork.myLC.fulfilled
    )
    builder.addCase(
      loginWithSocialNetwork.rejected,
      loginWithSocialNetwork.myLC.rejected
    )

    builder.addCase(register.pending, register.myLC.pending)
    builder.addCase(register.fulfilled, register.myLC.fulfilled)
    builder.addCase(register.rejected, register.myLC.rejected)

    builder.addCase(relogin.pending, relogin.myLC.pending)
    builder.addCase(relogin.fulfilled, relogin.myLC.fulfilled)
    builder.addCase(relogin.rejected, relogin.myLC.rejected)

    builder.addCase(verifyMailToken.pending, verifyMailToken.myLC.pending)
    builder.addCase(verifyMailToken.fulfilled, verifyMailToken.myLC.fulfilled)
    builder.addCase(verifyMailToken.rejected, verifyMailToken.myLC.rejected)

    builder.addCase(
      checkCurrentVerificationStatus.pending,
      checkCurrentVerificationStatus.myLC.pending
    )
    builder.addCase(
      checkCurrentVerificationStatus.fulfilled,
      checkCurrentVerificationStatus.myLC.fulfilled
    )
    builder.addCase(
      checkCurrentVerificationStatus.rejected,
      checkCurrentVerificationStatus.myLC.rejected
    )

    builder.addCase(
      canAskForMailVerificationTokenAgain.pending,
      canAskForMailVerificationTokenAgain.myLC.pending
    )
    builder.addCase(
      canAskForMailVerificationTokenAgain.fulfilled,
      canAskForMailVerificationTokenAgain.myLC.fulfilled
    )
    builder.addCase(
      canAskForMailVerificationTokenAgain.rejected,
      canAskForMailVerificationTokenAgain.myLC.rejected
    )

    builder.addCase(
      sendMailVerificationAgain.pending,
      sendMailVerificationAgain.myLC.pending
    )
    builder.addCase(
      sendMailVerificationAgain.fulfilled,
      sendMailVerificationAgain.myLC.fulfilled
    )
    builder.addCase(
      sendMailVerificationAgain.rejected,
      sendMailVerificationAgain.myLC.rejected
    )

    builder.addCase(
      generateChangePassToken.pending,
      generateChangePassToken.myLC.pending
    )
    builder.addCase(
      generateChangePassToken.fulfilled,
      generateChangePassToken.myLC.fulfilled
    )
    builder.addCase(
      generateChangePassToken.rejected,
      generateChangePassToken.myLC.rejected
    )

    builder.addCase(canChangePassword.pending, canChangePassword.myLC.pending)
    builder.addCase(
      canChangePassword.fulfilled,
      canChangePassword.myLC.fulfilled
    )
    builder.addCase(canChangePassword.rejected, canChangePassword.myLC.rejected)

    builder.addCase(changePassword.pending, changePassword.myLC.pending)
    builder.addCase(changePassword.fulfilled, changePassword.myLC.fulfilled)
    builder.addCase(changePassword.rejected, changePassword.myLC.rejected)

    builder.addCase(
      canAskForSMSverificationTokenAgain.pending,
      canAskForSMSverificationTokenAgain.myLC.pending
    )
    builder.addCase(
      canAskForSMSverificationTokenAgain.fulfilled,
      canAskForSMSverificationTokenAgain.myLC.fulfilled
    )
    builder.addCase(
      canAskForSMSverificationTokenAgain.rejected,
      canAskForSMSverificationTokenAgain.myLC.rejected
    )

    builder.addCase(
      sendSMSverificationAgain.pending,
      sendSMSverificationAgain.myLC.pending
    )
    builder.addCase(
      sendSMSverificationAgain.fulfilled,
      sendSMSverificationAgain.myLC.fulfilled
    )
    builder.addCase(
      sendSMSverificationAgain.rejected,
      sendSMSverificationAgain.myLC.rejected
    )

    builder.addCase(verifySMStoken.pending, verifySMStoken.myLC.pending)
    builder.addCase(verifySMStoken.fulfilled, verifySMStoken.myLC.fulfilled)
    builder.addCase(verifySMStoken.rejected, verifySMStoken.myLC.rejected)

    builder.addCase(deactivateAccount.pending, deactivateAccount.myLC.pending)
    builder.addCase(
      deactivateAccount.fulfilled,
      deactivateAccount.myLC.fulfilled
    )
    builder.addCase(deactivateAccount.rejected, deactivateAccount.myLC.rejected)
  },
})

export const asyncActions = {
  login,
  loginWithSocialNetwork,
  register,
  relogin,

  /* both verifications */
  checkCurrentVerificationStatus, //provjerava oba 2 statusa

  /* mail verifications */
  verifyMailToken, //verificira token koji se salje u parametru
  sendMailVerificationAgain, //salje ponovno mail ako je moguce
  canAskForMailVerificationTokenAgain, //javlja dal je moguce traziti mail ponovno

  /* sms verifications */
  verifySMStoken, //verificira sms koji je u parametru
  sendSMSverificationAgain, //salje ponovno sms ako je moguce
  canAskForSMSverificationTokenAgain, //javlja info dal je moguce sms traziti

  generateChangePassToken,
  canChangePassword,
  changePassword,

  deactivateAccount,
}
export const actions = loginSlice.actions
export default loginSlice.reducer
